import { render } from "./FacetsHeader.vue?vue&type=template&id=1c16170b"
import script from "./FacetsHeader.vue?vue&type=script&lang=js"
export * from "./FacetsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__